import React, { Component } from 'react';
import { Content } from './style';
import { withRouter } from 'react-router-dom';
import { CirclesFactory } from './CirclesFactory';
import Slider from 'react-slick';
import { subscribeToWorkout } from '../../../../../Services/handleSocketConnection';

export class Slides extends Component {
    constructor(props) {
        super(props);

        const workoutId = props.workoutId || props.match.params.workoutId;
        subscribeToWorkout(Number(workoutId), liveData => {
            if (liveData.user.status === 1) this.addActiveUser(liveData);
            else this.removeActiveUser(liveData);
        });

        this.state = {
            activeUsers: [],
            secondsLeft: 5,
            currentSlide: 0,
        };
    }

    componentDidMount() {
        this.startCountdown();
    }

    startCountdown = () => {
        this.countdown = setInterval(() => {
            this.tick();
        }, 1000);
    };

    tick = () => {
        this.setState(prevState => {
            let secondsLeft, currentSlide;
            if (prevState.secondsLeft === 0) {
                secondsLeft = 5;

                if (prevState.currentSlide === 2) currentSlide = 0;
                else currentSlide = ++prevState.currentSlide;
                this.slider.slickGoTo(currentSlide);

                return {
                    secondsLeft,
                    currentSlide,
                };
            }
            return {
                secondsLeft: --prevState.secondsLeft,
            };
        });
    };

    componentWillUnmount() {
        clearInterval(this.countdown);
    }

    getSettings = () => {
        return {
            dots: !this.props.isEmbed,
            infinite: !this.props.isEmbed,
            draggable: !this.props.isEmbed,
            speed: 500,
            slidesToShow: 1,
            accessibility: false,
            arrows: false,
            autoplay: false,
            // autoplaySpeed: 4500,
            pauseOnHover: false,
            beforeChange: (oldIndex, newIndex) => this.props.getCurrentSlide(newIndex),
        };
    };

    addActiveUser = ({ user, workout }) => {
        const userExists =
            this.state.activeUsers.findIndex(_user => _user !== undefined && _user.user.id === user.id) === -1
                ? false
                : true;

        if (!userExists) {
            const activeUsers = [...this.state.activeUsers, { user, workout }];
            this.setState({ activeUsers });
        } else {
            const index = this.state.activeUsers.findIndex(_user => _user !== undefined && _user.user.id === user.id);
            let activeUsers = this.state.activeUsers;

            if (activeUsers[index].hidden === true) activeUsers[index].hidden = false;

            activeUsers[index] = { user, workout };
            this.setState({ activeUsers });
        }
    };

    removeActiveUser = ({ user }) => {
        const removeIndex = this.state.activeUsers.findIndex(_user => _user !== undefined && _user.user.id === user.id);

        if (removeIndex === -1) return;
        let activeUsers = this.state.activeUsers;

        activeUsers[removeIndex].finished = true;

        this.setState({ activeUsers }, () => {
            setTimeout(() => {
                let activeUsers = this.state.activeUsers;
                activeUsers[removeIndex].hidden = true;
                // delete activeUsers[removeIndex];

                this.setState({ activeUsers });
            }, 30000);
        });
    };

    getHeartrateCircleType = activeUser => {
        if (activeUser.finished) return 3;
        if (!activeUser.workout.total_BPM) return 4;
        return 2;
    };

    getPercentageCircleType = activeUser => {
        if (activeUser.finished) return 3;
        if (!activeUser.workout.max_hr_percent) return 4;
        return 0;
    };

    getCaloriesCircleType = activeUser => {
        if (activeUser.finished) return 3;
        return 1;
    };

    render() {
        const {
            getSettings,
            state: { activeUsers },
            getHeartrateCircleType,
            getPercentageCircleType,
            getCaloriesCircleType,
        } = this;

        return (
            <Slider ref={slider => (this.slider = slider)} {...getSettings()}>
                {/* Heartrate percentage slide */}
                <Content>
                    {activeUsers.map((activeUser, index) => {
                        if (!activeUser.hidden) {
                            const circleType = getPercentageCircleType(activeUser);
                            return <CirclesFactory key={`percentage-${index}`} type={circleType} {...activeUser} />;
                        }
                    })}

                    <CirclesFactory type={5} />
                </Content>

                {/* Calories burned slide */}
                <Content>
                    {activeUsers.map((activeUser, index) => {
                        if (!activeUser.hidden) {
                            const circleType = getCaloriesCircleType(activeUser);
                            return <CirclesFactory key={`calories-${index}`} type={circleType} {...activeUser} />;
                        }
                    })}
                    <CirclesFactory type={5} />
                </Content>

                {/* Heartrate slide */}
                <Content>
                    {activeUsers.map((activeUser, index) => {
                        if (!activeUser.hidden) {
                            const circleType = getHeartrateCircleType(activeUser);
                            return <CirclesFactory key={`heartrate-${index}`} type={circleType} {...activeUser} />;
                        }
                    })}
                    <CirclesFactory type={5} />
                </Content>
            </Slider>
        );
    }
}

Slides = withRouter(Slides);



// WEBPACK FOOTER //
// ./src/UI/Containers/GymTv/LiveDisplay/Content/index.js